import loadable from '@loadable/component';

export default loadable(
  () => import(/* webpackChunkName: "inline.priceReveal" */ './Main')
);
